module.exports = __webpack_public_path__ + "assets/coins-a739d8.svg";